import { Component, EventEmitter, OnInit } from '@angular/core';
import { CourseNavigationService } from '../../../services/course-navigation.service';
import { DwCardBaseComponent, DwComponent, DwComponentType, DwMetaDataListCardConfigData, DwQueryMetaData, DwRoutingService } from '@devwareapps/devware-cap';
import { AppMetaDataItemNames, CourseEntity } from '../../../../../meta-data/app-meta-data.service';
import { SchoolRepositoryService } from '../../../../schools/services/school-repository.service';


@DwComponent<DwMetaDataListCardConfigData>({
  name: 'Course Marketplace Card',
  key: 'courseMarketplaceCard',
  componentType: DwComponentType.card,
  //configComponent: DwCardDefaultConfigComponent,
  isGlobal: false,
  parentItemName: AppMetaDataItemNames.Course,
  configData: {
    contentItemDefinitions: [{
      display: 'Main',
      contentItemKey: 'main'
    }]
  }
})
@Component({
  selector: 'app-course-marketplace-card',
  templateUrl: './course-marketplace-card.component.html',
  styleUrls: ['./course-marketplace-card.component.scss']
})
export class CourseMarketplaceCardComponent implements DwCardBaseComponent<any, CourseEntity> {
  marketplaceImageUrl = '/assets/aviator-online/img/marketplace-card.png';
  noCoursesAssignedImageUrl = '/assets/aviator-online/img/no-courses-card.png';
  courseImageUrl: string = '/assets/aviator-online/img/marketplace-card.png';

  cardText = 'No courses assigned!';
  
  isMarketplaceEnabled: boolean;
  setupComplete = false;
  onMyCourses: boolean;
  showNavigateToMarketplace = false;
  isMarketplaceCard: boolean;

  constructor(private courseNavigationService: CourseNavigationService,
    private schoolRepositoryService: SchoolRepositoryService,
    private dwRoutingService: DwRoutingService

  ) { }

  cardConfig?: any;
  data?: CourseEntity;
  resolvedContext?: any;
  queryMetaData?: DwQueryMetaData;

  setupCard() {
    
  }

  cardClick: EventEmitter<any>;

  ngOnInit(): void {

    this.onMyCourses = this.dwRoutingService.currentPageUrl === '/my-courses';

    this.schoolRepositoryService.getSchoolFeatures()
      .subscribe((schoolFeatures) => {  
        this.isMarketplaceEnabled = schoolFeatures.IsMarketplaceEnabled;

        if (this.isMarketplaceEnabled) {
          this.courseImageUrl = this.marketplaceImageUrl;
          this.showNavigateToMarketplace = true;
          if (this.onMyCourses) {
            this.courseImageUrl = this.noCoursesAssignedImageUrl;  
            this.showNavigateToMarketplace = false;
          }

          this.cardText = 'No courses assigned!';

          this.isMarketplaceCard = this.queryMetaData?.QueryMeaning?.indexOf('Marketplace') > -1;

          if (this.isMarketplaceCard) {
            this.cardText = 'No courses available for purchase!';
            this.showNavigateToMarketplace = false;
          }

        } else {
          this.courseImageUrl = this.noCoursesAssignedImageUrl;
          this.cardText = 'Contact your school for courses to be assigned';
        }

        this.setupComplete = true;
      });
  }

  click() {
    this.courseNavigationService.navigateToMyCourses();
  }
}
